// Module
var code = `<div class="row justify-content-center">
	<div class="col-12 col-md-8 col-lg-6">
		<div class="card">
			<div class="card-header">
				<back-button default-state="manager.settings" class="btn btn-outline-primary"></back-button>
				<span ng-if="!\$ctrl.edit" class="h4 card-title">New Scene</span>
				<span ng-if="\$ctrl.edit" class="h4 card-title">Edit Scene</span>
			</div>
			<form name="\$ctrl.clientForm" ng-submit="\$ctrl.submit(\$ctrl.clientForm.\$valid)">
				<div class="card-body">
					<div class="mb-3">
						<label for="name" class="form-label">Name</label>
						<input id="name" type="text" ng-model="\$ctrl.scene.name" placeholder="Give the Scene a name" required="required" minlength="1" class="form-control" />
					</div>
					<div class="mb-3">
						<label for="orientation" class="form-label">Orientation&nbsp;</label>
						<div id="orientation" role="group" aria-label="Orientation" class="btn-group">
							<button type="button" ng-class="{'active': \$ctrl.scene.orientation === 'l'}" ng-click="\$ctrl.scene.orientation = 'l'" class="btn btn-outline-primary">
								<i class="fas fa-arrows-left-right"></i>
								<span> Landscape</span>
							</button>
							<button type="button" ng-class="{'active': \$ctrl.scene.orientation === 'p'}" ng-click="\$ctrl.scene.orientation = 'p'" class="btn btn-outline-primary">
								<i class="fas fa-arrows-up-down"></i>
								<span> Portrait</span>
							</button>
						</div>
					</div>
					<div class="mb-3">
						<label for="color" class="form-label">Color</label>
						<input id="color" type="color" ng-model="\$ctrl.scene.color" placeholder="The color of the scene." class="form-control" list="colorList" />
						<datalist id="colorList">
							<option ng-repeat="color in \$ctrl.colors" value="{{color}}"></option>
						</datalist>
					</div>
					<div class="mb-3">
						<label for="clientId" class="form-label">Browser id (provided in "Configure Scenes")</label>
						<input id="clientId" name="clientId" type="text" ng-model="\$ctrl.scene.clientId" ng-change="\$ctrl.validateClientIdInput()" ng-class="{'is-invalid': \$ctrl.clientForm.clientId.\$invalid}" placeholder="The client id of the master of this Scene" class="form-control" />
						<div ng-if="\$ctrl.clientForm.clientId.\$invalid && \$ctrl.clientForm.clientId.\$dirty" class="invalid-feedback">Please enter a valid UUID or leave empty</div>
					</div>
				</div>
				<div class="card-footer d-flex justify-content-between">
					<button ng-if="\$ctrl.edit" type="button" ng-click="\$ctrl.remove()" ng-disabled="\$ctrl.sceneContent.length" class="btn btn-danger">
						<i class="far fa-trash-can"></i>
						<span>Delete</span>
					</button>
					<div ng-if="!\$ctrl.edit"></div>
					<button type="submit" ng-disabled="\$ctrl.isSaveDisabled()" class="btn btn-primary">
						<span ng-if="!\$ctrl.edit">Add</span>
						<span ng-if="\$ctrl.edit">Save</span>
					</button>
				</div>
			</form>
		</div>
	</div>
</div>
`;
// Exports
export default code;